require('./SearchItem.less');

var Base = require('front/components/Base/Base');

var _ = require('underscore/underscore.js');

require('dotdotdot');

module.exports = Base.extend({

    el: '.SearchItem',


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateEllipsis');

        Base.prototype.initialize.call(this, options);

        this.$('.SearchItem-text').dotdotdot({
            watch: true
        });

        window.app.vent.on('fonts-loaded', this.updateEllipsis);
    },


    updateEllipsis: function () {
        this.$('.SearchItem-text').trigger('update.dot');
    },


    destroy: function () {

        this.$('.SearchItem-text').trigger('destroy');

        window.app.vent.off('fonts-loaded', this.updateEllipsis);

        this.remove();
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SearchComponents/SearchItem.js
// module id = 240
// module chunks = 0